import React from "react";

import { observer } from "mobx-react";
import Link from "next/link";
import { Nav } from "react-bootstrap";
import styled from "styled-components";

import { useAppState } from "../../contexts/ApplicationStateProvider";
import { useStores } from "../../contexts/StoreContext";
import Icon from "../../shared/Icon/Icon";

const StyledNavLink = styled(Nav.Link)`
  text-decoration: none !important;
  transition: color 0.2s ease-in-out !important;
  font-weight: bold;
  font-size: 0.75rem;
  color: white !important;

  &.active {
    color: ${({ theme }) => theme.primaryColor} !important;
  }

  &:hover {
    color: ${({ theme }) => theme.negativeTextColor} !important;
  }

  &:focus {
    color: ${({ theme }) => theme.negativeTextColor} !important;
    border: 0 !important;
  }
`;

function ModeToggle() {
  const { configStore } = useStores();
  const { rolesModeConfig } = configStore.config;
  const { isInteractive, setIsInteractive } = useAppState();

  if (!rolesModeConfig) {
    return null;
  }

  return (
    !isInteractive &&
    rolesModeConfig?.enabled && (
      <Link href="/" passHref scroll={false} legacyBehavior>
        <StyledNavLink
          className="d-flex mb-3 mt-lg-0 mt-md-0 mt-5"
          onClick={() => setTimeout(() => setIsInteractive(true), 500)}
        >
          <Icon className="me-4" icon="arrowLeft" size={36} />
          OH MY GOSH. I MESSED UP SO BAD.
          <br />
          GET ME TO THE INTERACTIVE DEMO
        </StyledNavLink>
      </Link>
    )
  );
}

export default observer(ModeToggle);
